module.exports = __webpack_public_path__ + "img/mobile-spectrum-NIST-2.cd835c6d.png";